// Libraries
import moment from 'moment';
import React, {ComponentType} from 'react';
import BigCalendar, {View, EventPropGetter, ToolbarProps, Components} from 'react-big-calendar';

// Assets
import 'react-big-calendar/lib/css/react-big-calendar.css';
import './Calendar.css';

// const getLocalizer = ({isSundayFirst}) => {
//   if (!isSundayFirst) {
//     moment.updateLocale(
//       'us',
//       {
//         week: {
//           dow: 1,
//           doy: 1,
//         },
//       }
//     );
//   }
//   return BigCalendar.momentLocalizer(moment);
// };

const localizer = BigCalendar.momentLocalizer(moment);

interface CalendarProps {
  hasToolbar?: boolean;
  isSundayFirst?: boolean;
  date: string;
  events?: any[];
  view?: View;
  views?: View[];
  eventPropGetter?: EventPropGetter<any> | undefined;
  onNavigate?: (newDate: Date) => void;
  onView?: (view: View) => void;
  dateCellWrapperComponent: ComponentType<any>;
  dateHeaderComponent?: ComponentType<any> | undefined;
  eventComponent?: ComponentType<any> | undefined;
  toolbarComponent?: ComponentType<ToolbarProps> | undefined;
}

const Calendar = ({
  hasToolbar = true,
  date,
  events = [],
  view = 'month' as View,
  views = ['month'] as View[],
  eventPropGetter,
  onNavigate = () => {},
  onView = () => {},
  dateCellWrapperComponent,
  dateHeaderComponent,
  eventComponent,
  toolbarComponent,
}: CalendarProps) => (
  <BigCalendar
    components={
      {
        dateCellWrapper: dateCellWrapperComponent,
        dateHeader: dateHeaderComponent,
        event: eventComponent,
        toolbar: toolbarComponent,
      } as Components<any>
    }
    date={moment(date).toDate()}
    drilldownView={null} // Disables drilling down into a single day.
    events={events}
    localizer={localizer}
    toolbar={hasToolbar}
    view={view}
    views={views}
    eventPropGetter={eventPropGetter}
    onNavigate={onNavigate}
    onView={onView}
  />
);

export default Calendar;
